<div class="cart-container">
  <div class="row">
    <div class="col-lg-12">
      <div class="page-title">
        <!-- TODO move to cart page in shop-->
        <h1> {{ "modeso_cart_cart-icon-label" | injectedText | async }} </h1>
      </div>
    </div>
  </div>
  <div class="row" id="productId" *ngIf="carts.cart">
    <div class="col-lg-12" *ngIf="carts.cart?.products?.length > 0;else empty_cart">
      <lidl-lib-cart-fe-product-list [products]='carts?.cart?.products'
        (currentCartId)="emitCurrentCartId($event)"></lidl-lib-cart-fe-product-list>
    </div>
    <ng-template #empty_cart>
      <div class="col-lg-12 alert alert-danger text-center" role="alert" id="productMessage">
        {{ "modeso_cart_cart_empty" | injectedText | async }}
      </div>
    </ng-template>
  </div>

  <div class="row">
    <div class="col-lg-7"></div>
    <div class="col-lg-5">
      <ng-content *ngTemplateOutlet="deliveryRef"></ng-content>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-7"></div>
    <div class="col-lg-5 action-footer">
      <cart-total-option [cartTotalPrice]='carts?.totalPrice' [additionalCharges]='additionalCharges'>
      </cart-total-option>
      <ng-content select="[afterTotal]"></ng-content>
    </div>
  </div>

</div>
